import { SingleResponse } from "@/src/core/response"
import { sendRequest } from "@/src/core/http-client"
import MerchantBenefits from "@/src/interfaces/benefits/merchant"

export class MerchantBenefitsService {
    static async getPromotions(param: MerchantBenefits.SearchParams, appAccessToken?: string): Promise<SingleResponse<MerchantBenefits.PromotionResponse>> {
        const baseUrl = `${process.env.NEXT_PUBLIC_BENEFITS_URL}/promotions`

        const params = new URLSearchParams()

        if (param.merchantId) params.append('MerchantId', param.merchantId)
        if (param.dayOfWeek) params.append('DayOfWeek', param.dayOfWeek)
        if (param.timeOfDay) params.append('TimeOfDay', param.timeOfDay)
        if (param.visibleLevel) params.append('VisibleLevel', param.visibleLevel)
        if (param.productId) params.append('ProductId', param.productId)
        if (param.filterDependencies) params.append('FilterDependencies', `${param.filterDependencies}`)
        if (param.hasScheduleFilter) params.append('HasScheduleFilter', `${param.hasScheduleFilter}`)
        if (param.hasProductFilter) params.append('HasProductFilter', `${param.hasProductFilter}`)
        if (param.pageSize) params.append('PageSize', `${param.pageSize}`)
        if (param.page) params.append('Page', `${param.page}`)
        if (param.sortingColumn) params.append('SortingColumn', param.sortingColumn)
        if (param.sortingDirection) params.append('SortingDirection', param.sortingDirection)

        if (!param.filterDependencies)
            params.append('FilterDependencies', 'true')

        if (!param.dayOfWeek)
            params.append('DayOfWeek', new Date().toLocaleDateString('en-US', { weekday: "long" }))

        if (!param.timeOfDay)
            params.append('TimeOfDay', new Date().toLocaleTimeString('en-US', { hour12: false }))

        const finalUrl = `${baseUrl}?${params.toString()}`

        const response = await sendRequest<MerchantBenefits.PromotionResponse>(appAccessToken, finalUrl, 'GET', undefined, undefined)

        if (response.model) {
            const now = new Date()
            const currentDay = new Date().toLocaleDateString('en-US', { weekday: "long" })

            const currentTime = now.toLocaleTimeString('en-US', { hour12: false })

            const activePromotions = response.model.promotions?.filter(promotion =>
                promotion.schedules.some(schedule =>
                    schedule.dayOfWeek === currentDay &&
                    schedule.startTime <= currentTime &&
                    schedule.endTime >= currentTime
                )
            )

            if (activePromotions)
                response.model.promotions = activePromotions
        }

        return response
    }
}